export const REQUEST_EXERCISES: 'EXERCISES/REQUEST_EXERCISES' = 'EXERCISES/REQUEST_EXERCISES';
export const REQUEST_EXERCISES_SUCCESS: 'EXERCISES/REQUEST_EXERCISES/SUCCESS' = 'EXERCISES/REQUEST_EXERCISES/SUCCESS';
export const PRESELECT_EXERCISE: 'EXERCISES/PRESELECT_EXERCISE' = 'EXERCISES/PRESELECT_EXERCISE';
